import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcaQuestionIconComponent } from './components/eca-question-icon/eca-question-icon.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EcaGhostBtnComponent } from './components/eca-ghost-btn/eca-ghost-btn.component';
import { FormsModule } from '@angular/forms';
import { EcaInputGuideComponent } from './components/eca-input-guide/eca-input-guide.component';
import { CommonsModule } from '../common/commons.module';
import { EcaModalHostComponent } from './components/eca-modal-host/eca-modal-host.component';
//import { BreadcrumbModule } from 'xng-breadcrumb';
import { EcaDatePickerComponent } from './components/eca-date-picker/eca-date-picker.component';
import { EcaInputComponent } from './components/eca-input/eca-input.component';
import { EcaHtmlEditorComponent } from './components/eca-html-editor/eca-html-editor.component';
import { QuillModule } from 'ngx-quill';
import { EcaSelectComponent } from './components/eca-select/eca-select.component';
import { EcaConfirmModalComponent } from './components/eca-confirm-modal/eca-confirm-modal.component';
import { NgxPrintModule } from 'ngx-print';
import { EcaAppVersionComponent } from './components/eca-app-version/eca-app-version.component';
import { EcaHelpAlertComponent } from './components/eca-help-alert/eca-help-alert.component';
import { EcaCheckboxComponent } from './components/eca-checkbox/eca-checkbox.component';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { EcaRowMenuComponent } from './components/eca-row-menu/eca-row-menu.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ImageModule } from 'primeng/image';
import { EcaImageViewerComponent } from './components/eca-image-viewer/eca-image-viewer.component';
import { FileUploadModule } from 'primeng/fileupload';
import { EcaMarqueeComponent } from './components/eca-marquee/eca-marquee.component';


@NgModule({
  declarations: [EcaQuestionIconComponent,
    EcaGhostBtnComponent,
    EcaInputGuideComponent,
    EcaModalHostComponent,
    EcaDatePickerComponent,
    EcaInputComponent,
    EcaHtmlEditorComponent,
    EcaSelectComponent,
    EcaConfirmModalComponent,
    EcaAppVersionComponent,
    EcaHelpAlertComponent,
    EcaCheckboxComponent,
    EcaRowMenuComponent,
    EcaImageViewerComponent,
    EcaMarqueeComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    CommonsModule,
    //BreadcrumbModule,
    QuillModule,
    NgxPrintModule,
    TableModule,
    CalendarModule,
    TooltipModule,
    MenuModule,
    CheckboxModule,
    ImageModule,
    FileUploadModule
  ],
  exports: [
    EcaQuestionIconComponent, EcaGhostBtnComponent, EcaInputGuideComponent, EcaModalHostComponent, EcaDatePickerComponent, EcaInputComponent, EcaHtmlEditorComponent, EcaSelectComponent, EcaAppVersionComponent, EcaHelpAlertComponent, EcaCheckboxComponent, EcaRowMenuComponent, EcaImageViewerComponent, EcaMarqueeComponent
  ]
})
export class SharedModule {
}
